import * as React from "react";
import { closeWebview } from "@core-utils/utils/Native";
import { RouteContext } from "@swiggy-private/core-ui";

export const useOnBack = (): ((numberOfTimesToGoBack?: number) => void) => {
    const { canGoBack } = React.useContext(RouteContext);
    //numberOfPagesToGoBack can be passed as a argument to onBack function to send the user back a few pages
    const onBack = React.useCallback(
        (numberOfPagesToGoBack = 1): void => {
            if (canGoBack(numberOfPagesToGoBack)) {
                history.go(-1 * numberOfPagesToGoBack);
                return;
            }

            closeWebview();
        },
        [canGoBack],
    );

    return onBack;
};
